import { render, staticRenderFns } from "./newGovernmentSector.vue?vue&type=template&id=0875efb2&"
import script from "./newGovernmentSector.vue?vue&type=script&lang=js&"
export * from "./newGovernmentSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports